import { render, staticRenderFns } from "./FluctuationForm.vue?vue&type=template&id=31729db5&scoped=true"
import script from "./FluctuationForm.vue?vue&type=script&lang=ts"
export * from "./FluctuationForm.vue?vue&type=script&lang=ts"
import style0 from "./FluctuationForm.vue?vue&type=style&index=0&id=31729db5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31729db5",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/engagement-form/fluctuation-form.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsearch%2Fengagement-form%2FFluctuationForm.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports